var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-breadcrumb",
        {
          staticStyle: { float: "right" },
          attrs: { "separator-class": "el-icon-arrow-right" }
        },
        [
          _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
            _vm._v(" " + _vm._s(_vm.$t("route.home")))
          ]),
          _vm._v(" "),
          _c(
            "el-breadcrumb-item",
            { attrs: { to: { name: "categoryList" } } },
            [_vm._v(_vm._s(_vm.$t("entities.category.plural")))]
          ),
          _vm._v(" "),
          _c("el-breadcrumb-item", [_vm._v(_vm._s(_vm.$t("table.history")))])
        ],
        1
      ),
      _vm._v(" "),
      _c("h2", { staticClass: "page-title" }, [
        _vm._v(" " + _vm._s(_vm.$t("entities.category.plural")) + " history")
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ]
        },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.list,
                "empty-text": "There is no history yet",
                border: ""
              }
            },
            [
              _c("el-table-column", {
                attrs: { prop: "modified", label: "Updated at", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("formatDatetime")(scope.row.modified)
                            ) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Updated by", prop: "modifiedBy.email" }
              }),
              _vm._v(" "),
              _c("el-table-column", { attrs: { prop: "name", label: "Name" } }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "created", label: "Created at", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("formatDatetime")(scope.row.created)
                            ) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Created by", prop: "createdBy.email" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "deleted", label: "Deleted at", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("formatDatetime")(scope.row.deleted)
                            ) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Deleted by", prop: "deletedBy.email" }
              })
            ],
            1
          ),
          _vm._v(" "),
          !_vm.last
            ? _c(
                "el-button",
                {
                  staticClass: "mt-3 w-100",
                  attrs: { type: "infor", icon: "el-icon-fa-plus" },
                  on: {
                    click: function($event) {
                      _vm.fetch()
                    }
                  }
                },
                [_vm._v("\n      Load more...\n    ")]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-24da51fc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24da51fc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/category/category-history/category-history-full/category-history-full.vue
// module id = null
// module chunks = 